import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import {
    ApiRequestService,
    DialogService,
    FilterPipe,
    MAT_ICON,
    TOAST_STATE,
    ToastmessageService,
    TranslationService
} from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { GetProductsResponse } from '../../products/product-list/get-products.response';
import { Material } from '../../products/product-list/material.model';
import { AddDiscountpriceDialogComponent } from '../addproductsonsale/adddiscountpricedialog/adddiscountpricedialog.component';
import { AddDiscountPriceDialogResult } from '../addproductsonsale/adddiscountpricedialog/adddiscountpricedialogresult';
import { AddDiscountPriceRequest } from '../addproductsonsale/adddiscountpricedialog/adddiscountpricerequest';
import { OnSalePeriod } from '../addproductsonsale/onsaleperiod';
import { GetOnSalePeriodRequest } from './getonsaleperiodrequest';
import { GetOnSalePeriodResponse } from './getonsaleperiodresponse';
import { GetProductsForOnSalePeriodRequest } from './getproductsforonsaleperiodrequest';
import { GetProductsForOnSalePeriodResponse } from './getproductsforonsaleperiodresponse';
import { UpdateOnSalePeriodRequest } from './updateonsaleperiodrequest';
import { UpdateOnSalePeriodResponse } from './updateonsaleperiodresponse';

@Component({
    selector: 'app-updateonsale',
    templateUrl: './updateonsale.component.html',
    styleUrls: ['./updateonsale.component.scss'],
    standalone: true,
    imports: [MatIconModule, ReactiveFormsModule, FormsModule, CommonModule, FilterPipe, RouterModule, MatDialogModule]
})
export class UpdateonsaleComponent implements OnInit {

    endDate = '';
    getOnSalePeriodRequest: GetOnSalePeriodRequest = {};
    getOnSalePeriodUrl = '/admin/get-on-sale-period';
    getProductsForOnSalePeriodRequest: GetProductsForOnSalePeriodRequest = {};
    getProductsForOnSalePeriodUrl = '/admin/get-on-sale-products';
    getProductsUrl = '/store/get-products';
    onSalePeriod: OnSalePeriod = {};
    products: Material[] = [];
    saleForm?: FormGroup;
    searchText = '';
    startDate = '';
    storeBaseUrl = '';
    updateableProducts: Material[] = [];
    updateOnSalePeriodRequest: UpdateOnSalePeriodRequest = {};
    updateOnSalePeriodUrl = '/admin/update-on-sale-period';
    isExtraSmall: Observable<BreakpointState>;
    originalProductRouterLinkList: string[] = [];
    private _dialogService = inject(DialogService);
    addDiscountPriceUrl = '/admin/add-discount-price';

    constructor(
        public _router: Router,
        private _fb: FormBuilder,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _apiRequestService: ApiRequestService,
        private _toastMessageService: ToastmessageService,
        private _translateService: TranslationService,
        private readonly _breakpointObserver: BreakpointObserver
    ) {
        this.storeBaseUrl = _storeBaseUrl;
        this.isExtraSmall = this._breakpointObserver.observe(Breakpoints.XSmall);
        this.createSaleForm();
    }

    ngOnInit(): void {
        if (sessionStorage.getItem('token')) {
            this.onInitData();
        } else {
            this._router.navigateByUrl('/');
        }
    }

    onInitData() {
        const lastSegmentOfUrl = window.location.href.split('/').pop();
        const routerLink = lastSegmentOfUrl as string;
        this.getOnSalePeriodRequest = {
            routerLink: routerLink
        };

        this._apiRequestService
            .sendRequest<
                GetOnSalePeriodRequest,
                GetOnSalePeriodResponse
            >(this.storeBaseUrl, this.getOnSalePeriodRequest, true, this.getOnSalePeriodUrl)
            .subscribe((response) => {
                this.onSalePeriod = response.onSalePeriod as OnSalePeriod;
                this.startDate = this.onSalePeriod.startDate as string;
                this.endDate = this.onSalePeriod.endDate as string;
                this.getProductsForOnSalePeriod(this.onSalePeriod.routerLink!);
            });
    }

    getProductsForOnSalePeriod(routerLink: string) {
        this.getProductsForOnSalePeriodRequest = {
            routerLink: routerLink
        };

        this._apiRequestService
            .sendRequest<
                GetProductsForOnSalePeriodRequest,
                GetProductsForOnSalePeriodResponse
            >(this.storeBaseUrl, this.getProductsForOnSalePeriodRequest, true, this.getProductsForOnSalePeriodUrl)
            .subscribe((response) => {
                this.updateableProducts = response.products as Material[];
                this.originalProductRouterLinkList = this.updateableProducts.map(p => p.routerLink!);
                this.getProducts();
            });
    }

    getProducts() {
        this._apiRequestService.sendRequest(this.storeBaseUrl, {}, true, this.getProductsUrl).subscribe((response) => {
            const products = response as GetProductsResponse;
            this.products = products.productList as Material[];
            products.productList!.forEach((product) => {
                if (!product.isAvailable) {
                    const index = this.products.indexOf(product);
                    this.products.splice(index, 1);
                }
            });

            //skipping same elements with updateAbleProducts from products
            this.products = this.products.filter((p) => !this.updateableProducts.some((p2) => p2.routerLink === p.routerLink));
        });
    }

    private dismissErrorFiveSeconds(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 5000);
    }

    createSaleForm() {
        this.saleForm = this._fb.group({
            onSaleEndDate: ['', [Validators.required]],
            onSaleStartDate: ['', [Validators.required]],
            onSaleName: ['', [Validators.required]]
        });
    }

    collectOnSalePeriodData() {
        this.onSalePeriod.name = this.saleForm?.controls['onSaleName'].value as string | undefined;
        this.onSalePeriod.startDate = this.startDate;
        this.onSalePeriod.endDate = this.endDate;
    }

    addProductToOnSale(product: Material) {
        if (!product.discountPrice) {
            this.openDiscountPriceDialog(product);
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.error,
                this._translateService.translate('Kérem adja meg az akciós a ' + product.author + ':' + product.title + ' könyvhöz!'),
                MAT_ICON.error
            );
            this.dismissErrorFiveSeconds();
        } else {
            const index = this.products.indexOf(product);
            this.products.splice(index, 1);
            this.updateableProducts.push(product);
        }
    }

    deleteFromOnSaleProductList(product: Material) {
        const index = this.updateableProducts.indexOf(product);
        this.updateableProducts.splice(index, 1);
        this.products.push(product);
    }

    updateOnSalePeriod() {
        this.collectOnSalePeriodData();
        const currentProductIds = this.updateableProducts.map(p => p.routerLink!);
        const newProductRouterLinkList = currentProductIds.filter(routerLink => !this.originalProductRouterLinkList.includes(routerLink));
        const removeableProductRouterLinkList = this.originalProductRouterLinkList.filter(id => !currentProductIds.includes(id));

        this.updateOnSalePeriodRequest = {
            onSalePeriod: this.onSalePeriod,
            newProductRouterLinkList: newProductRouterLinkList,
            removeableProductRouterLinkList: removeableProductRouterLinkList
        };

        this._apiRequestService
            .sendRequest<
                UpdateOnSalePeriodRequest,
                UpdateOnSalePeriodResponse
            >(this.storeBaseUrl, this.updateOnSalePeriodRequest, true, this.updateOnSalePeriodUrl, true)
            .subscribe(() => {
                this.originalProductRouterLinkList = [...currentProductIds];
            });
    }

    onChangeStartDate(event: Event) {
        const target = event.target as HTMLInputElement;

        this.startDate = target.value;
    }

    onChangeEndDate(event: Event) {
        const target = event.target as HTMLInputElement;

        this.endDate = target.value;
    }

    openDiscountPriceDialog(product: Material) {
        this._dialogService.openDialog(
            AddDiscountpriceDialogComponent,
            null,
            ((addDiscountPriceDialogResult: AddDiscountPriceDialogResult | undefined) => {
                this.addDiscountPrice(addDiscountPriceDialogResult?.discountPrice!, product)
            }
            )
        )
    }

    addDiscountPrice(discountPrice: number, product: Material) {
        const addDiscountPriceRequest: AddDiscountPriceRequest = {
            discountPrice: discountPrice,
            productId: product.id
        };

        this._apiRequestService
            .sendRequest<
                AddDiscountPriceRequest,
                HttpResponse<any>
            >(this.storeBaseUrl, addDiscountPriceRequest, true, this.addDiscountPriceUrl)
            .subscribe(() => {
                const productIndex = this.products.indexOf(product);
                this.products.splice(productIndex, 1);
                this.updateableProducts.push(product);
            });
    }
}
